export enum ProcessingScreenType {
  ReimburseMyself = 'REIMBURSE_MYSELF',
  PayMyProvider = 'PAY_MY_PROVIDER',
  HowToProcessPlanClaims = 'HOW_TO_PROCESS_PLAN_CLAIMS',
  PayeeIsNotDetermined = 'PAYEE_IS_NOT_DETERMINED',
}
